/**
 * Validates an activation code against format definitions
 */
const activationCodeValidator = (code) => {
  return /^\d{5}$/.test(code)
}

export {
  activationCodeValidator
}
export default {
  methods: {
    activationCodeValidator
  }
}
